import { Typography, type TypographyProps } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useUnitsFormatter } from "hooks/formatters";
import { useNumberSerialiser } from "hooks/serialisers/numbers";
import type { MaterialQuantityUnit } from "src/store/api/generatedApi";

export const FormattedMass = ({
  value,
  unit,
  showSign = false,
  variant = "body2",
}: {
  value: number;
  unit: MaterialQuantityUnit;
  showSign?: boolean;
  variant?: TypographyProps["variant"];
}) => {
  const { format } = useNumberSerialiser({ decimalPlaces: 1 });
  const unitsFormatter = useUnitsFormatter(false);
  const theme = useTheme();

  return (
    <Typography
      variant={variant}
      sx={{
        fontWeight: "fontWeightMedium",
        whiteSpace: "nowrap",
        color:
          value > 0 ? theme.palette.primary.main : theme.palette.error.main,
      }}
    >
      {showSign ? (value > 0 ? "+" : "-") : null}
      {format(Math.abs(value))}
      {unit === "mass" ? unitsFormatter("mass") : null}
    </Typography>
  );
};
